import { render, staticRenderFns } from "./safeQuestion.vue?vue&type=template&id=661fdad0&scoped=true&"
import script from "./safeQuestion.vue?vue&type=script&lang=js&"
export * from "./safeQuestion.vue?vue&type=script&lang=js&"
import style0 from "./safeQuestion.vue?vue&type=style&index=0&id=661fdad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661fdad0",
  null
  
)

export default component.exports